import { h, render } from "preact";
import { Provider } from "react-redux";

import store from "./store/salaryCalculatorStore";

import SalaryCalculatorForm from "./components/loggedOutSalaryCalculator/SalaryCalculatorForm.jsx";
import SalaryCalculatorResult from "./components/loggedOutSalaryCalculator/SalaryCalculatorResult.jsx";

document.addEventListener("DOMContentLoaded", function () {
  const formElement = document.getElementById("salary-calc-form-app");

  const calcType =
    formElement.getAttribute("data-calculation-type") || "salary";

  if (formElement) {
    formElement.innerHTML = "";
    render(
      <Provider store={store}>
        <SalaryCalculatorForm type={calcType} />
      </Provider>,
      formElement
    );
  }

  const resultElement = document.getElementById("salary-calc-result-app");
  if (resultElement) {
    render(
      <Provider store={store}>
        <SalaryCalculatorResult type={calcType} />
      </Provider>,
      resultElement
    );
  }
});
